//#region Libraries
import { Row } from "components/styles";
import styled from "styled-components";
//#endregion

export const Container = styled(Row).attrs({
	gap: "10px",
	wrap: "nowrap"
})`
	width: 100%;
	& svg {
		width: 20px;
	}
	& path {
		fill: var(--dark-4);
	}
`;